// extracted by mini-css-extract-plugin
module.exports = {"infoGroup":"infoGroup_infoGroup__11w5k","title":"infoGroup_title__1hQDX","infoRow":"infoGroup_infoRow__2PKzQ","label":"infoGroup_label__118Gi","values":"infoGroup_values__2TZuV"};